<template>
    <div id="favorites_btn" 
        class="favorites-btn"
        :class="(is_open_dialog) ? 'open' : 'close'"
    >
        <div v-if="show_favorites_btn_notice"
            class="btn-notice__content"
        >
            我的最愛 ! 請參考使用說明 <br>
            關於 > 怎麼用 > 操作說明
            <button class="btn-notice__btn"
                @click="not_show_favorites_btn_notice"
            >
                知道了
            </button>
        </div>

        <!-- 地圖右上角的愛心icon -->
        <div class="favorites-btn__container">
            <v-icon 
                class="favorites-btn__icon"
                @click.stop="open_dialog()"
            >
                icon-heart-regular
            </v-icon>

            <span class="favorites-btn__text">
                {{ $t('__favorites.hint_text') }}
            </span>
        </div>

        <!-- 點擊地圖右上角的愛心icon，可以控制 <FavoritesSettingItems> 的顯示與否 -->
        <FavoritesSettingItems 
            v-if="is_open_dialog"
            class="setting-items"
            @close_dialog="close_dialog()"
            @change_favorites_hint_text="change_favorites_hint_text"
        />
    </div>
</template>

<script>
    export default {
        name: 'Favorites',
        components: {
            'FavoritesSettingItems': () => import('@/components/favorites/favorites_setting_items.vue'),
        },

        data() {
            return {
                is_open_dialog: false,
                show_favorites_btn_notice: true
            }
        },
        
        mounted() {
            this.show_favorites_btn_notice = !localStorage.getItem('show_favorites_btn_notice');
        },
        
        methods: {
            open_dialog () {
                this.is_open_dialog = !this.is_open_dialog;
                this.not_show_favorites_btn_notice();
            },

            close_dialog () {
                this.is_open_dialog = false;
            },

            change_favorites_hint_text(text) {
                this.$emit('change_favorites_hint_text', text);
            },

            not_show_favorites_btn_notice() {
                this.show_favorites_btn_notice = false;
                localStorage.setItem('show_favorites_btn_notice', 'show once');
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../css/mixin.scss';

    .favorites-btn {
        position: relative;
        margin: 0.6rem;
        margin-top: -0.1rem;
        z-index: 2;

        width: 2rem;
        height: 2rem;
        border-radius: 1rem;
        background-color: var(--base-gray);

        &__container {
            position: relative;

            display: flex;
            align-items: center;
            justify-content: center;
            
            font-weight: bold;
            cursor: pointer;
            background-color: transparent;
            color: white;
        }

        &__icon {
            height: 24px;
            width: 24px;
            margin-top: 4px;
            font-size: 14px;
            background-size: 100%;
            color: var(--grey-pipe);
        }

        &__text {
            position: absolute;
            right: 2rem;
            display: none;
            
            margin-right: 0.5rem;
            padding: 0.4em 0.8em;

            font-size: 0.8rem;
            white-space: nowrap;
        }

        &.close {
            background-color: var(--aqua-active);
            border: solid 1px var(--aqua-active);

            .favorites-btn__icon {     
                color: var(--base_black);
            }
        }

        &.open {
            background-color: var(--base_black);
            border: solid 1px var(--aqua-active);

            .favorites-btn__icon {
                color: var(--aqua-active)
            }
        }

        @include device-hoverable{
            &__container:hover {
                .favorites-btn__icon {
                    color: var(--aqua-active)
                }
                .favorites-btn__text {
                    display: block;
                }
            }
        }

        .setting-items {
            position: absolute;
            top: 0;
            right: 2.4rem;
        }
    }

    .favorites-btn:has(.favorites-btn__container:hover) {
        background-color: var(--base_black);
        border: solid 1px var(--aqua-active);
    }

    .btn-notice__content {
        --color: #454d66;
        position: absolute;
        z-index: 1;
        top: -15px;
        right: calc(100% + 30px);
        width: 280px;
        padding: 20px;
        text-align: center;
        font-size: 1rem;
        letter-spacing: 2px;
        border-radius: 10px;
        color: #fff;
        background: var(--color);

        &::before {
            content: '';
            position: absolute;
            left: 100%;
            top: 15px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 15px 0 15px 30px;
            border-color: transparent transparent transparent var(--color);
        }
    }

    .btn-notice__btn {
        margin: 10px 0 0 0;
        padding: 5px 10px;
        border-radius: 5px;
        font-weight: bold;
        background: var(--aqua-active);
        color: var(--base-dark-blue);

        &:hover {
            color: var(--aqua-active);
            background: var(--base-dark-blue);
        }
    }
</style>
